'use client';

import { AuthProvider, ProtectedComponent } from "@/components/AuthProvider";
import { useState, useEffect } from 'react';
import { debug } from '../utils/logger';

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
    </div>
  );
}

function ClientSideProvider({ children }) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    debug('[ClientSideProvider] Effect running');
    setIsClient(true);
  }, []);

  debug('[ClientSideProvider] Rendering with isClient:', isClient);

  if (!isClient) {
    debug('[ClientSideProvider] Showing loading fallback');
    return <LoadingFallback />;
  }

  debug('[ClientSideProvider] Rendering auth provider');
  return (
    <AuthProvider>
      <ProtectedComponent>
        <div className="flex flex-col min-h-screen">
          {children}
        </div>
      </ProtectedComponent>
    </AuthProvider>
  );
}

export function Providers({ children }) {
  debug('[Providers] Rendering providers wrapper');
  return <ClientSideProvider>{children}</ClientSideProvider>;
}